// © Microsoft Corporation. All rights reserved.
const subscriptions = new Map();
/**
 * Registers a subscription. Subscriptions are requests that get notified multiple times.
 * @param message - the message from main thread with subscription id
 */
export function registerSubscription(message) {
    subscriptions.set(message.id, message);
}
/**
 * Sends a message to the main thread
 * @param message the message to send
 */
export function sendMessage(message) {
    postMessage(message);
}
/**
 * Send a postMessage to the main thread
 * @param id message id
 * @param payload payload
 */
export function notifySubscription(id, payload) {
    if (!subscriptions.has(id)) {
        return;
    }
    sendMessage({ id, fetched: true, payload });
}
//# sourceMappingURL=PostMessage.js.map